import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './QuickPick.css';
import './HomePage.css';
import Cookies from 'js-cookie';

const QuickPick = () => {
    const [media, setMedia] = useState({ movies: [], 'tv-shows': [] });
    const [currentList, setCurrentList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentItem, setCurrentItem] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedMediaType, setSelectedMediaType] = useState(null);
    const [watchSoon, setWatchSoon] = useState([]);
    const username = Cookies.get("username") || 'default';
    const [timerWidth, setTimerWidth] = useState(0);
    const [allDoneClicked, setAllDoneClicked] = useState(false);
    const [quickPickSelected, setQuickPickSelected] = useState(false);
    const location = useLocation();
    const [currentImageIndex, setCurrentImageIndex] = useState(1);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const mediaType = searchParams.get('m');
        if (mediaType === 'tv-shows' || mediaType === 'movies') {
            setSelectedMediaType(mediaType);
        }

        const storedList = localStorage.getItem('sortedWatchList');
        if (storedList) {
            const parsedList = JSON.parse(storedList);
            setCurrentList(parsedList);
        }

        // Set the current image index to a random number between 1 and 8
        setCurrentImageIndex(Math.floor(Math.random() * 8) + 1);

        fetch(`/api/watchlist/${username}`)
            .then(response => response.json())
            .then(data => {
                const movies = data.movies?.map(item => item[1]).sort(() => Math.random() - 0.5) || [];
                const tvShows = data['tv-shows']?.map(item => item[1]).sort(() => Math.random() - 0.5) || [];
                fetchTrendingMedia(movies, tvShows);
            })
            .catch(error => {
                console.error('Error fetching watchlist:', error);
                fetchTrendingMedia([], []);
            });
    }, [location.search, username]);

    const fetchTrendingMedia = (watchlistMovies, watchlistTvShows) => {
        Promise.all([
            fetch('/trending/daily/movies').then(response => response.json()),
            fetch('/trending/daily/tv').then(response => response.json())
        ]).then(([moviesData, tvShowsData]) => {
            const trendingMovies = moviesData.searchResults.results.map(item => ({
                tmdb_id: item.id,
                title: item.title || item.name,
                release_date: item.release_date || item.first_air_date,
                full_poster_path: `https://image.tmdb.org/t/p/w500/${item.poster_path}`,
                overview: item.overview,
                vote_average: item.vote_average,
                vote_count: item.vote_count,
                media_type: 'movie'
            })).sort((a, b) => b.popularity - a.popularity);

            const trendingTvShows = tvShowsData.searchResults.results.map(item => ({
                tmdb_id: item.id,
                title: item.title || item.name,
                release_date: item.release_date || item.first_air_date,
                full_poster_path: `https://image.tmdb.org/t/p/w500/${item.poster_path}`,
                overview: item.overview,
                vote_average: item.vote_average,
                vote_count: item.vote_count,
                media_type: 'tv'
            })).sort((a, b) => b.popularity - a.popularity);

            const uniqueMovies = removeDuplicates([...watchlistMovies, ...trendingMovies]);
            const uniqueTvShows = removeDuplicates([...watchlistTvShows, ...trendingTvShows]);

            setMedia({ movies: uniqueMovies, 'tv-shows': uniqueTvShows });
            setIsLoading(false);
        }).catch(error => {
            console.error('Error fetching trending media:', error);
            setIsLoading(false);
        });
    };

    const removeDuplicates = (items) => {
        const seen = new Set();
        return items.filter(item => {
            const isDuplicate = seen.has(item.tmdb_id);
            seen.add(item.tmdb_id);
            return !isDuplicate;
        });
    };

    const saveToLocalStorage = (finalList) => {
        localStorage.setItem('sortedWatchList', JSON.stringify(finalList));
        localStorage.setItem(`sortedWatchList-${selectedMediaType}`, JSON.stringify(finalList));
    };

    useEffect(() => {
        if (selectedMediaType && quickPickSelected && media[selectedMediaType]?.length > 0) {
            const newList = media[selectedMediaType];
            setCurrentList(newList);
        }
    }, [selectedMediaType, media, quickPickSelected]);

    useEffect(() => {
        if (currentList.length > 0) {
            setCurrentItem(currentList[0]);
            setCurrentIndex(0);
        }
    }, [currentList]);

    useEffect(() => {
        if (currentItem) {
            const intervalId = setInterval(() => {
                setTimerWidth(prevWidth => {
                    if (prevWidth >= 100) {
                        clearInterval(intervalId);
                        moveToNext();
                        return 100;
                    }
                    return prevWidth + (100 / 60);
                });
            }, 100);

            return () => {
                clearInterval(intervalId);
                setTimerWidth(0);
            };
        }
    }, [currentItem]);


    const handleWatchSoon = () => {
        const updatedWatchSoon = [...watchSoon, currentItem];
        setWatchSoon(updatedWatchSoon);
        if (updatedWatchSoon.length >= 5) {
            handleAllDone('/');
        } else {
            moveToNext();
        }
    };


    const moveToNext = () => {
        setCurrentIndex(prev => {
            const nextIndex = prev + 1;
            if (nextIndex < currentList.length) {
                setCurrentItem(currentList[nextIndex]);
            } else {
                setCurrentItem(null);
            }
            return nextIndex;
        });
    };

    const renderFinalList = () => {
        const finalList = sortedFinalList();
        saveToLocalStorage(finalList);
        return (
            <div className="grid-container">
            </div>
        );
    };

    const handleQuickPickSelection = (type) => {
        setSelectedMediaType(type);
        setQuickPickSelected(true);
        clearLists();
    };

    const clearLists = () => {
        setWatchSoon([]);
        setCurrentItem(null);
        setCurrentIndex(0);
    };

    const sortedFinalList = () => {
        const sortedSoon = [...watchSoon].sort((a, b) => b.vote_average - a.vote_average);
        const unselected = currentList.slice(currentIndex);
        return [...sortedSoon, ...unselected];
    };

    const handleAllDone = () => {
        const finalWatchNowList = sortedFinalList();
        saveToLocalStorage(finalWatchNowList);
        setCurrentItem(null);
        setCurrentIndex(currentList.length);
        setAllDoneClicked(true);

        const redirectSection = selectedMediaType === 'movies' ? 'movies' : 'tv';
        window.location.href = `/home?section=${redirectSection}`;
    };

    return (
        <>
        
        <div className="quick-pick-container">            
            {isLoading ? (
                <p>Loading...</p>
            ) : (
                <div className="quick-pick-content" >
                    {// QUICK PICK INTRO SECTION STARTS HERE
                    } 
                    {!quickPickSelected && (
                        <div style={{
                            textAlign: "center",
                            padding: "40px 20px",
                            maxWidth: "700px",
                            margin: "0 auto",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            borderRadius: "16px",
                            backdropFilter: "blur(8px)"
                        }}>
                            <h1 style={{ fontSize: "36px", color: "white", fontWeight: "bold", marginBottom: "16px" }}>
                                Choose your adventure
                            </h1>
                            <p style={{ fontSize: "18px", color: "#ccc", marginBottom: "30px" }}>
                                In this lightning round, you'll be shown a series of trending TV shows or movies.
                                Decide quickly—tap "Watch" to save it to your Top Picks, or "Later" to skip.
                                You only get 5 picks, so make each one count. When you're done, we'll take you straight to your updated watchlist!
                            </p>
                            <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => handleQuickPickSelection('tv-shows')}
                                    style={{ fontSize: "18px", padding: "15px 25px", borderRadius: "10px", minWidth: "160px" }}
                                >
                                    📺 TV Shows
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => handleQuickPickSelection('movies')}
                                    style={{ fontSize: "18px", padding: "15px 25px", borderRadius: "10px", minWidth: "160px" }}
                                >
                                    🎬 Movies
                                </button>
                            </div>
                        </div>
                    )}
                    { // QUICK PICK INTRO SECTION ENDS HERE
                    }                    
                    {selectedMediaType && quickPickSelected && currentItem && (
                        <>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                position: 'relative',
                                padding: '30px 10px 10px',
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                borderRadius: '16px',
                                backdropFilter: 'blur(8px)',
                                width: '90%',
                                maxWidth: '900px',
                                margin: '0 auto 10px'
                            }}>
                                <span style={{ color:"white", fontSize: "20px", marginBottom: "5px" }}>Don't think, just pick.</span>

                                {/* Overlay buttons at the bottom of the poster */}
                                <div style={{
                                    position: 'absolute',
                                    bottom: '0',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    display: 'flex',
                                    gap: '16px',
                                    width: '100%',
                                    justifyContent: 'center',
                                    padding: '12px',
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    borderBottomLeftRadius: '16px',
                                    borderBottomRightRadius: '16px',
                                    zIndex: 2
                                }}>
                                    <button
                                        className='btn btn-secondary'
                                        onClick={moveToNext}
                                        style={{
                                            position: 'relative',
                                            padding: '10px 20px',
                                            fontSize: '16px',
                                            borderRadius: '8px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <i className="fa fa-times" style={{ marginRight: '6px' }}></i>
                                        Later
                                        <div className='timer' style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            height: '3px',
                                            backgroundColor: 'lightgray',
                                            width: `${timerWidth}%`
                                        }}></div>
                                    </button>
                                    <button
                                        className='btn btn-primary'
                                        onClick={handleWatchSoon}
                                        style={{
                                            padding: '10px 20px',
                                            fontSize: '16px',
                                            borderRadius: '8px'
                                        }}
                                    >
                                        <i className="fa fa-play" style={{ marginRight: '6px' }}></i>
                                        Watch
                                    </button>
                                </div>

                                {/* Poster image */}
                                <img
                                    src={currentItem.full_poster_path}
                                    alt={currentItem.title}
                                    style={{
                                        width: '100%',
                                        maxWidth: '300px',
                                        borderRadius: '16px',
                                        boxShadow: '0 6px 16px rgba(0,0,0,0.6)',
                                        marginTop: '40px',
                                        marginBottom: '10px'
                                    }}
                                />
                            </div>

                        </>
                    )}
                    {/* Removed manual "All Done" button and alert for >=3 picks */}
                    
                    {!currentItem && currentList.length > 0 && (
                        renderFinalList()
                    )}
                    {/* (Bottom action bar replaced by new layout above) */}
                </div>
            )}
        <span style={{ color:"white", fontSize: "20px", zIndex:1,height:"300px" }}>  </span>
        </div>
        </>
    );
};

export default QuickPick;
